/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Save_20Inputs */

const en_common_save_20 = /** @type {(inputs: Common_Save_20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save 20%`)
};

const de_common_save_20 = /** @type {(inputs: Common_Save_20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20% sparen`)
};

const fr_common_save_20 = /** @type {(inputs: Common_Save_20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Économise 20%`)
};

const es_common_save_20 = /** @type {(inputs: Common_Save_20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahorre 20%`)
};

const it_common_save_20 = /** @type {(inputs: Common_Save_20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risparmia il 20%`)
};

const nl_common_save_20 = /** @type {(inputs: Common_Save_20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bespaar 20%`)
};

const pl_common_save_20 = /** @type {(inputs: Common_Save_20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oszczędź 20%`)
};

const fi_common_save_20 = /** @type {(inputs: Common_Save_20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Säästä 20%`)
};

const da_common_save_20 = /** @type {(inputs: Common_Save_20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spar 20%`)
};

const sv_common_save_20 = /** @type {(inputs: Common_Save_20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spara 20%`)
};

/**
* | output |
* | --- |
* | "Save 20%" |
*
* @param {Common_Save_20Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const common_save_20 = /** @type {((inputs?: Common_Save_20Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Save_20Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_common_save_20(inputs)
	if (locale === "fr") return fr_common_save_20(inputs)
	if (locale === "es") return es_common_save_20(inputs)
	if (locale === "it") return it_common_save_20(inputs)
	if (locale === "nl") return nl_common_save_20(inputs)
	if (locale === "pl") return pl_common_save_20(inputs)
	if (locale === "fi") return fi_common_save_20(inputs)
	if (locale === "da") return da_common_save_20(inputs)
	if (locale === "sv") return sv_common_save_20(inputs)
	return en_common_save_20(inputs)
});